export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-5--g1.2d471622.png";